import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { X } from 'lucide-react'
import { STORAGE_KEYS } from '@/constants'
import { useSettings } from '@/context/SettingsContext'
import { formatPrice } from '@/utils/formatPrice'

/**
 * Top-of-page announcement. The threshold is the owner's live setting from
 * /admin/settings — the same number the cart uses to waive the fee — so the
 * banner can never promise a different amount than checkout applies.
 */
export function PromoBanner() {
  const { freeDeliveryThreshold } = useSettings()
  const [visible, setVisible] = useState(() => {
    try {
      const dismissed = sessionStorage.getItem(STORAGE_KEYS.promoBannerDismissed)
      return !dismissed
    } catch {
      return true
    }
  })

  const dismiss = () => {
    setVisible(false)
    try {
      sessionStorage.setItem(STORAGE_KEYS.promoBannerDismissed, '1')
    } catch {
      /* ignore */
    }
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="relative z-40 bg-coral text-white"
        >
          <div className="mx-auto flex max-w-7xl items-center justify-center gap-4 px-4 py-2 text-sm font-medium">
            <span className="text-center">
              🎉 Free delivery on orders over{' '}
              <strong>{formatPrice(freeDeliveryThreshold)}</strong>!
            </span>
            <button
              type="button"
              onClick={dismiss}
              aria-label="Dismiss promo banner"
              className="ml-auto rounded-full p-1 transition hover:bg-white/20"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
